import {$get} from "../../core/js/Ajax.ts";
import {$} from "../../core/js/Dom.ts";

document.addEventListener('DOMContentLoaded', () => {
    if(document.body.dataset.url === 'aide-admin-instance') {
        $get('/forum/suivi/', { request: 'accueil_admin_instance'}).then(({body}) => {
            const element = $('#topic_open_forum')
            if(element && body) element.innerHTML = body
        })
    }
})